import axios from "axios";
import axiosInstance from "../helpers/axiosInstance";


export const fetchChartPendingOrders = async (params = { }) => {
    
    const res = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/fulfillment-tasks/count-pending-orders`,{params})
    return res.data
}
